import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

import { inWhitelabel, getWhitelabelConfig } from 'core/whitelabel';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { AccessForm } from 'apps/profile/accessForm';
import { SignInForm } from 'apps/signIn/views/signInForm';
import { WhiteLabelForm } from 'apps/signIn/views/whitelabelForm';
import { SingleOAuthForm } from 'apps/signIn/views/singleOAuthForm';
import { ResetPasswordModal } from 'apps/signIn/resetPassword/index';

@withNamespaces()
@observer
export class SignInPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = clientStore.context.get('signInAppManager');

    const currentRoute = clientStore.routerStore.route;
    if (!currentRoute.params.next) {
      clientStore.routerStore.navigate(
        currentRoute.name,
        { ...currentRoute.params, next: '/' },
        { replace: true },
      );
    }
  }

  clickNoAccount() {
    clientStore.routerStore.navigate('home.signUp', {
      next: clientStore.next(),
    });
  }

  clickForgotPassword() {
    modalStore.SetModalComponent(ResetPasswordModal);
  }

  clickRequestInvite() {
    modalStore.SetModalComponent(AccessForm);
  }

  render() {
    let FormComponent = SignInForm;
    if (inWhitelabel()) {
      if (getWhitelabelConfig().onlyOAuthSignIn) {
        FormComponent = SingleOAuthForm;
      } else {
        FormComponent = WhiteLabelForm;
      }
    }
    return (
      <FormComponent
        form={this.appManager.signInApp.form}
        title={<div className='flex-center text-center'>Welcome back to Wikifactory</div>}
        handleForgotPassword={this.clickForgotPassword}
        handleSignIn={this.appManager.signInApp.SignIn}
        handleNoAccount={this.clickNoAccount}
        handleRequestInvite={this.clickRequestInvite}
      />
    );
  }
}

SignInPage.propTypes = {
  t: PropTypes.func,
};
